/* Purchase and state feedback, paired with section-ts-motion.css.
   - cart-update (the theme's pubsub): the cart count bounces and the cart
     icon nudges, so an add registers even before the drawer slides in.
   - Cart drawer: its lines slide in at the moment it opens. The class is
     set only on the closed -> open change, so quantity edits (which
     re-render the lines inside the open drawer) don't replay it.
   - Pack picker: the chosen pack's radio mark pops.
   - Price: the price painted at load is marked data-ts-seen; the theme
     replaces the price markup on a pack change, and only that new price
     animates.
   - Articles: a reading-progress bar (drawn by CSS, only in browsers with
     scroll-driven animations).
   Loaded after theme.js. Does nothing under prefers-reduced-motion. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // animationend bubbles, so match the keyframes name: the cart count's
  // bounce ending must not cut short the cart icon's nudge around it.
  function replay(el, cls, keyframes) {
    el.classList.remove(cls);
    void el.offsetWidth;            // restart the animation if it just ran
    el.classList.add(cls);
    el.addEventListener('animationend', function done(e) {
      if (e.animationName !== keyframes) return;
      el.classList.remove(cls);
      el.removeEventListener('animationend', done);
    });
  }

  function onCartUpdate(event) {
    if (event && event.cart && event.cart.errors) return;
    document.querySelectorAll('cart-count').forEach(function (count) {
      if (count.hidden) return;
      replay(count, 'ts-bump', 'ts-bump');
      var trigger = count.closest('a, button');
      if (trigger) replay(trigger, 'ts-cart-nudge', 'ts-nudge');
    });
  }

  function watchDrawer(drawer) {
    var wasOpen = drawer.hasAttribute('open');
    var timer;
    new MutationObserver(function () {
      var open = drawer.hasAttribute('open');
      if (open && !wasOpen) {
        drawer.classList.add('ts-enter');
        clearTimeout(timer);
        timer = setTimeout(function () { drawer.classList.remove('ts-enter'); }, 1000);
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  function onPackChange(event) {
    var radio = event.target;
    if (!radio.classList || !radio.classList.contains('ts-tiers__radio')) return;
    var row = radio.closest('.ts-tiers__row');
    var mark = row && row.querySelector('.ts-tiers__mark');
    if (mark) replay(mark, 'ts-pop', 'ts-pop');
  }

  function markPrices() {
    document.querySelectorAll('[id^="price-template"] .f-price').forEach(function (p) {
      p.setAttribute('data-ts-seen', '');
    });
    document.documentElement.classList.add('ts-live');
  }

  function readingProgress() {
    if (!document.body.classList.contains('article-template')) return;
    if (!(window.CSS && CSS.supports('animation-timeline: scroll()'))) return;
    if (document.querySelector('.ts-progress')) return;
    var bar = document.createElement('div');
    // no-empty: theme.css hides every empty div unless it carries this class.
    bar.className = 'ts-progress no-empty';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }

  function start() {
    var pubsub = window.FoxTheme && window.FoxTheme.pubsub;
    if (pubsub) pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    document.querySelectorAll('cart-drawer').forEach(watchDrawer);
    document.addEventListener('change', onPackChange);
    markPrices();
    readingProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
